import moment from "moment";
import 'moment/locale/ru.js'
import { useLocale } from "next-intl";
import { useEffect } from "react";

export const useMomentLocalization = () => {
  const local = useLocale()

  // moment 的国际化
  useEffect(() => {
    const loadLocale = async () => {
      let lang = local

      if (local === 'zh-CN') {
        lang = 'zh-cn'
      } else if (local === 'zh-TW')
        lang = 'zh-tw'
      if (lang !== 'en')
        await import(`moment/locale/${lang}`);
      moment.locale(lang);
    };

    loadLocale();
  }, [local])

}